import * as React from "react";
import { observer, inject } from "mobx-react";
import { Link } from "react-router-dom";

import ProfileLink from "../common/ProfileLink";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserAlt, faBriefcase, faFlag, faGavel } from "@fortawesome/free-solid-svg-icons";

import { HorseForSaleStateFriendlyName } from "../../model/HorseForSale";
import { HorseForSaleStore } from "../../stores/HorseForSaleStore";

import Application from "./Application";
import AcknowledgementComponent from "./AcknowledgementComponent";
import DocumentsAndCompliance from "./DocumentsAndCompliance";
import Checkout from "./Checkout";
import Inspection from "./Inspection";
import SelectionAndWithdrawal from "./SelectionAndWithdrawal";
import { HorseLink } from "../common/HorseLink";

export interface Props {
    horseForSaleStore?: HorseForSaleStore;
    currentTab: string;
}
export interface State {}

@inject("horseForSaleStore")
@observer
export class HorsesForSaleProfile extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.props.horseForSaleStore!.refresh();
    }

    render() {
        const { horseForSaleStore } = this.props;
        if (!horseForSaleStore) {
            throw new Error(" ** No Horse For Sale Store **");
        }

        const horseForSale = horseForSaleStore.horseForSale;
        if (!horseForSale) {
            return <div />;
        }

        const horse = horseForSale.horse;

        return (
            <div>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item active">
                            <Link to="/horses-for-sale">Horses for sale</Link>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                            Horse For Sale Profile
                        </li>
                    </ol>
                </nav>
                <div className="content">
                    <div className="row">
                        <div className="col-8">
                            <h1>
                                <span>
                                    <FontAwesomeIcon icon={faGavel} size="2x" className="mr-2 color-info" />
                                </span>
                                {horseForSale.hipNumber && `#${horseForSale.hipNumber} `}
                                <HorseLink horse={horse} targetBlank={true} className="horse-for-sale-header-link" />{" "}
                                <span style={{ fontSize: "70%" }}>({horseForSale.sale.name})</span>
                            </h1>
                        </div>
                        <div className="col-4 text-right mt-2">
                            <h2>State: {HorseForSaleStateFriendlyName(horseForSale.state)}</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3 col-lg-4 col-xl-3">
                            <div className="card shadow">
                                <div className="card-header">Profile Menu</div>
                                <nav className="flex-column  intern-navigation">
                                    <ul>
                                        <ProfileLink
                                            label="Application"
                                            type="horses-for-sale"
                                            numberId={horseForSale.id}
                                            page="application"
                                            active={this.props.currentTab === "application"}
                                        />
                                        <ProfileLink
                                            label="Inspection"
                                            type="horses-for-sale"
                                            numberId={horseForSale.id}
                                            page="inspection"
                                            active={this.props.currentTab === "inspection"}
                                        />
                                        <ProfileLink
                                            label="Selection &amp; Withdrawal"
                                            type="horses-for-sale"
                                            numberId={horseForSale.id}
                                            page="selection-and-withdrawal"
                                            active={this.props.currentTab === "selection-and-withdrawal"}
                                        />
                                        <ProfileLink
                                            label="Documents &amp; Compliance"
                                            type="horses-for-sale"
                                            numberId={horseForSale.id}
                                            page="documentation"
                                            active={this.props.currentTab === "documentation"}
                                        />
                                        <ProfileLink
                                            label="Acknowledgement of Purchase and Acceptance of Conditions Form"
                                            type="horses-for-sale"
                                            numberId={horseForSale.id}
                                            page="acknowledgement"
                                            active={this.props.currentTab === "acknowledgement"}
                                        />
                                        <ProfileLink
                                            label="Checkout"
                                            type="horses-for-sale"
                                            numberId={horseForSale.id}
                                            page="checkout"
                                            active={this.props.currentTab === "checkout"}
                                        />
                                    </ul>
                                </nav>
                            </div>
                        </div>
                        <div className="col-md-9 col-lg-8 col-xl-9">
                            {this.props.currentTab === "application" && <Application />}
                            {this.props.currentTab === "inspection" && <Inspection />}
                            {this.props.currentTab === "selection-and-withdrawal" && <SelectionAndWithdrawal />}
                            {this.props.currentTab === "documentation" && <DocumentsAndCompliance />}
                            {this.props.currentTab === "acknowledgement" && <AcknowledgementComponent />}
                            {this.props.currentTab === "checkout" && <Checkout />}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/horses-for-sale/HorsesForSaleProfile.tsx